import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(VDataTable, {
        key: _vm.keyDashboardsList,
        staticClass: "text-center table-inca",
        attrs: {
          responsive: "",
          hover: "",
          items: _vm.items,
          headers: _vm.headers,
          "hide-default-footer": "",
          "disable-pagination": "",
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function (ref) {
              var item = ref.item
              var index = ref.index
              return [
                _c(
                  "div",
                  { staticClass: "d-flex justify-space-around" },
                  [
                    item.report.maintenance
                      ? _c(
                          VTooltip,
                          {
                            attrs: { top: "", "nudge-width": "0" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    var attrs = ref.attrs
                                    return [
                                      _c(
                                        VBtn,
                                        _vm._g(
                                          _vm._b(
                                            { attrs: { icon: "" } },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c(VIcon, [
                                            _vm._v("mdi-information-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [_c("span", [_vm._v("En mantenimiento")])]
                        )
                      : _c(
                          VCol,
                          [
                            _c(
                              VTooltip,
                              {
                                attrs: { top: "", "nudge-width": "0" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.verInfo(item)
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(VIcon, [
                                                _vm._v(
                                                  "mdi-information-outline"
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "customer_insights.label.view_info"
                                      )
                                    )
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              VTooltip,
                              {
                                attrs: { top: "", "nudge-width": "0" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            VBtn,
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.onVer(item)
                                                    },
                                                  },
                                                },
                                                "v-btn",
                                                attrs,
                                                false
                                              ),
                                              on
                                            ),
                                            [
                                              _c(
                                                VIcon,
                                                { attrs: { dense: "" } },
                                                [_vm._v("icon-view")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [_c("span", [_vm._v("Ver")])]
                            ),
                            _vm.canDownload
                              ? _c(
                                  VTooltip,
                                  {
                                    attrs: { top: "", "nudge-width": "0" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                VBtn,
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        name: "somos1_report_item",
                                                        "data-hash-email":
                                                          "asdad",
                                                        "data-region": "Lima",
                                                        "data-company": "032",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.onDownload(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(VIcon, [
                                                    _vm._v(
                                                      "mdi-arrow-collapse-down"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [_c("span", [_vm._v("Descargar dataentry")])]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "item.last_update",
            fn: function (ref) {
              var item = ref.item
              var index = ref.index
              return [
                _c(
                  "div",
                  { staticClass: "d-flex justify-space-around" },
                  [
                    _c(
                      VTooltip,
                      {
                        attrs: { top: "", "nudge-width": "0" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  _c(
                                    "span",
                                    _vm._g(
                                      _vm._b({}, "span", attrs, false),
                                      on
                                    ),
                                    [_vm._v(_vm._s(item.last_update))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.last_update_message))])]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _c("dialogs-component", {
        ref: _vm.DIALOG_INFO_VIEW,
        attrs: {
          title: _vm.$t("customer_insights.label.info"),
          "show-buttons": false,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("customer_insights.label.last_info_updated")
                    ) +
                    " "
                ),
                _c("br"),
                _c("b", [_vm._v(_vm._s(_vm.last_updated_contact))]),
                _c("br"),
                _vm._v(
                  " " + _vm._s(_vm.$t("customer_insights.label.last_info_date"))
                ),
                _c("br"),
                _vm._v(" "),
                _c("b", [_vm._v(_vm._s(_vm.last_updated_date))]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }